import axios from "axios"
import useJwt from "@src/auth/jwt/useJwt"
const config = useJwt.jwtConfig

// ?? Languages apis
const getLanguages = (isActive, shortname) => axios.get(`${config.url}/foreign/language`, { params: { isActive, shortname } })

const getLanguage = (id) => axios.get(`${config.url}/foreign/language/${id}`)

const activateLanguage = (languageId, status) => axios.post(`${config.url}/foreign/language`, { languageId, status })

const uploadFile = (formData) => axios.post(`${config.url}/foreign/language/upload-file`, formData)

const addLanguage = (params) => axios.post(`${config.url}/foreign/language/add`, params)

const editLanguage = (id, params) => axios.put(`${config.url}/foreign/language/${id}`, params)

const deleteLanguage = (id) => axios.delete(`${config.url}/foreign/language/${id}`)

// ?? Words apis
const getWords = (search, categoryId) => axios.get(`${config.url}/foreign/language/word`, { params: { search, categoryId } })

const getWordsByCode = (code) => axios.get(`${config.url}/foreign/language/word/list/${code}`)

const getWordsById = (wordId) => axios.get(`${config.url}/foreign/language/word/${wordId}`)

const getWordsByKey = (key) => axios.get(`${config.url}/foreign/language/word/key/${key}`)

const addWord = (params) => axios.post(`${config.url}/foreign/language/word`, params)

const updateWord = (key, params) => axios.put(`${config.url}/foreign/language/word/${key}`, params)

const deleteWord = (id) => axios.delete(`${config.url}/foreign/language/word/${id}`)

// ?? Categories apis
const getCategories = (fullname) => axios.get(`${config.url}/foreign/language/category`, { params: { fullname } })

const getCategoriesSelectList = (fullname) => axios.get(`${config.url}/foreign/language/category/select/list`, { params: { fullname } })

const getCategoriesById = (id) => axios.get(`${config.url}/foreign/language/category/${id}`)

const addCategory = (params) => axios.post(`${config.url}/foreign/language/category`, params)

const updateCategory = (id, params) => axios.put(`${config.url}/foreign/language/category/${id}`, params)

const deleteCategory = (id) => axios.delete(`${config.url}/foreign/language/category/${id}`)

// ?? Categories apis
const getReferences = (fullname) => axios.get(`${config.url}/foreign/language/reference/list`, { params: { fullname } })

const getReferenceById = (id, categoryId) => axios.get(`${config.url}/foreign/language/reference/${id}`, { params: { categoryId } })

const getReferenceByCategory = (id) => axios.get(`${config.url}/foreign/language/reference/categories/${id}`)

const addReference = (id, params) => axios.post(`${config.url}/foreign/language/reference/register/${id}`, params)

const updateReference = (referenceId, id, params) => axios.put(`${config.url}/foreign/language/reference/update/${referenceId}/${id}`, params)

const deleteReference = (referenceId, id) => axios.delete(`${config.url}/foreign/language/reference/delete/${referenceId}/${id}`)

export const languagesApi = {
  // ?? Languages apis
  getLanguages,
  getLanguage,
  activateLanguage,
  uploadFile,
  addLanguage,
  editLanguage,
  deleteLanguage,
  // ?? Words apis
  getWords,
  getWordsByCode,
  getWordsById,
  getWordsByKey,
  addWord,
  updateWord,
  deleteWord,
  // ?? Categories apis
  getCategories,
  getCategoriesSelectList,
  getCategoriesById,
  addCategory,
  updateCategory,
  deleteCategory,
  // ?? Categories apis
  getReferences,
  getReferenceById,
  getReferenceByCategory,
  addReference,
  updateReference,
  deleteReference
}
